import { UntypedFormGroup } from '@angular/forms';
import { PodAndSupplierPartnerNumberContractResponse } from '@eredes/microservices';
import { Subject } from 'rxjs';

export class GeneralDataViewModel {
  constructor(
    public formGroup: UntypedFormGroup,
    public formNameCPE: string,
    public errorsMessageCPE: any,
    public placeHolderCPE: string,
    public formNameProcessIdentification: string,
    public errorsMessageProcessIdentification: any,
    public placeHolderProcessIdentification: string,
    public showProcessIdentification = true,
    public showBillingdDate: boolean,
    public formNameBillingDate: string,
    public placeHolderBillingDate: string,
    public errorsMessageBillingDate: any,
    public formNamePartnerNumber: string,
    public formNameAnotherNif: string,
    public errorMessageAnotherNif: any,
    public showAnotherNif: boolean,
    public modalTitle: string,
    public selectedNif?: string,
    public selectedName?: string,
    public messageErrorPartnerNumber?: string,
    public openModal: Subject<boolean> = new Subject<boolean>(),
    public contractsObs: Subject<PodAndSupplierPartnerNumberContractResponse[]> = new Subject<
      PodAndSupplierPartnerNumberContractResponse[]
    >()
  ) {}
}
